module.exports = __webpack_public_path__ + "img/hzhs9.fe23a06a.jpg";